import React, { useState, useEffect } from "react";
import {
  Link, Switch, Route
} from "react-router-dom";
import { Helmet } from "react-helmet";
import { connect } from 'react-redux';

import NestedResults from "../reddit/nestedresults";
import ErrorBar from "../common/errorBar";
import FeaturePaywallWrapper from "../account/featurePaywallWrapper";

import { redditService } from '../../services/reddit';
import { savedSearchesService } from '../../services/savedSearches';
import { savedSearchOperations } from "../../redux/saved"

import { trackEvent } from '../../utils/tracking';
import { getConversationCsvDict } from '../../utils/reddit';


const SavedConversationsSimilar = ({
  history,
  location,
  savedSearch,
  currentUser,
  baseUrl, // needed b/c this gets shown on multiple potential screens
  collectionHash, // optional collection hash to filter by subreddits
}) => {

  const [results, setResults] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [fetchingExtra, setFetchingExtra] = useState(false);
  const [error, setError] = useState(null);

  const sortOptions = ['Recent', 'Upvotes', 'Comments']
  const [sortOption, setSortOption] = useState(sortOptions[0]);

  useEffect(() => {
    if (savedSearch) {
      fetchSimilarConversations();
    }
  }, [savedSearch, collectionHash]);

  const fetchSimilarConversations = () => {
    setFetching(true);
    setError(null);
    
    // Build params object
    let params = {};
    if (collectionHash) {
      params.collection_hash = collectionHash;
    }
    
    savedSearchesService.getSavedSearchSimilar(savedSearch.hash, params, (response) => {
      const similarResults = response.data.results || [];
      setResults(similarResults);
      fetchExtras(similarResults);
      setFetching(false);
    }, (error, response) => {
      setFetching(false);
      if (error.response && error.response.status === 404) {
        setError("Similar conversations can only be found for bookmarked saved searches. This feature is only available for manually curated conversation lists.");
      } else {
        setError(response || "Error fetching similar conversations");
      }
    });
  };

  // gets extra data on this query, updates results
  const fetchExtras = (currentResults) => {
    if (!currentResults || !currentResults.length) return; // don't call extras if there's nothing to do
    const ids = currentResults.map(r => r.id);
    const allFilters = {"ids": ids, "type": "reddit-all", "backend": "praw"};
    setFetchingExtra(true);
    redditService.getConversationExtras(allFilters,
      (response) => {
        // update responses based on the IDs
        const updates = response.data;
        var newResults = currentResults.map((r) => {
          if (updates[r.id]){
            r = Object.assign(r, updates[r.id])
          }
          return r
        });
        setResults(newResults);
        setFetchingExtra(false);
      }, (error, response) => {
        setFetchingExtra(false);
        console.error("error fetching extras", response)
      });
  };

  // sort based on user-input
  var sortedResults = results;
  if (sortOption === "Upvotes"){
    sortedResults = sortedResults.sort((a,b) => (a.score < b.score) ? 1 : ((b.score < a.score) ? -1 : 0));
  } else if (sortOption === "Comments"){
    sortedResults = sortedResults.sort((a,b) => (a.num_comments < b.num_comments) ? 1 : ((b.num_comments < a.num_comments) ? -1 : 0));
  } else if (!sortOption || sortOption === "Recent"){
    // should be default
    sortedResults = sortedResults.sort((a,b) => (a.timestamp_utc < b.timestamp_utc) ? 1 : ((b.timestamp_utc < a.timestamp_utc) ? -1 : 0));
  }

  return (
    <div className="overflow-y-auto h-full">
      <FeaturePaywallWrapper featureKey={"similar-conversations"} className={'max-w-full p-4 m-4'} 
        currentUser={currentUser}
      >
        <React.Fragment>
          <Helmet><title>Conversations | Saved | Similar</title></Helmet>
          {error ? (
            <ErrorBar error={error} setError={setError} onRetry={fetchSimilarConversations}/>
          ) : (
            <NestedResults fetching={fetching || fetchingExtra}
              results={sortedResults} keyword={null}
              baseUrl={baseUrl + 'similar/'} location={location} history={history}
              currentUser={currentUser}
              showHeader={true}
              sortOptions={sortOptions} sortOption={sortOption} setSortOption={setSortOption}
              loaderSpecial={true}
              // loaderSpecialMessage="Finding similar conversations may take up to 10 seconds..."
            />
          )}
        </React.Fragment>
      </FeaturePaywallWrapper>
    </div>
  );
};

export default SavedConversationsSimilar;
